import axios from "axios";
import PRODUCTS_DATA from "./data";
import { config } from "./../Constants";

export const getProducts = () => {
  return PRODUCTS_DATA;
};
 const configHeaders = {
  "content-type": "application/json",
  "Accept": "application/json",
  "Access-Control-Allow-Origin": '*',
  "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
  "Access-Control-Allow-Headers": "origin, x-requested-with, content-type"
}; 

export const getCustomerDetail = () =>
  // Object.values(PRODUCTS_DATA).find((product) => product.id === id);
  axios.get(
    `${config.url}/modules/sodexoproduct/api/beneficiaries.php?method=getCustomer`
  ).then((response) => response.data);

  export const getBeneficiariesList = () =>
  // Object.values(PRODUCTS_DATA).find((product) => product.id === id);
  axios.get(
    `${config.url}/modules/sodexoproduct/api/beneficiaries.php?method=getList`
  ).then((response) => response.data);

export const getProductById = (id) =>
  // Object.values(PRODUCTS_DATA).find((product) => product.id === id);
  axios.get(
    `${config.url}/api/products/${id}?ws_key=IC21MCAG663XUB2TVE2EJFKQE963M62A&output_format=JSON&language=1`
    ).then((response) => (response.data));

export const getCategoryById = async (id) => {
  let res = await axios.get(
    `${config.url}/api/categories/${id}?ws_key=IC21MCAG663XUB2TVE2EJFKQE963M62A&output_format=JSON&language=1`
  );
  return await res.data;
};
export const getCartTotal = () => axios.get(
  `${config.url}/modules/sodexoproduct/api/beneficiaries.php?method=getCartTotal`
).then((response) => response.data);
export const disableCardNumber = ({cardNumber,status}) =>
 
  axios.post(
    `${config.url}/modules/sodexoproduct/api/beneficiaries.php?method=disableCardNumber`
    ,{cardNumber, status}).then((response=>response.data));
 





